/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ActionTokenEntity = {
  type: 'Enum',
} as const;
